import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

const propTypes = {

	/**
	 * Flag indicating if the button is active.
	 */
	active: PropTypes.bool,

	/**
	 * Flag indicating if the button should be block styled.
	 */
	block: PropTypes.bool,

	/**
	 * The custom CSS classes (if any) to add to the button.
	 */
	className: PropTypes.string,

	/**
	 * The color of the button.
	 */
	color: PropTypes.oneOf([
		'primary',
		'secondary',
		'success',
		'info',
		'warning',
		'danger',
		'neutral',
		'light',
		'dark',
		'link',
	]),

	/**
	 * Flag indicating if the button is disabled.
	 */
	disabled: PropTypes.bool,

	/**
	 * Flag indicating if the button should be outline only.
	 */
	outline: PropTypes.bool,

	/**
	 * Flag indicating if the button is loading.
	 */
	showLoading: PropTypes.bool,

	/**
	 * The size of the button.
	 */
	size: PropTypes.oneOf(['sm', 'lg']),

	/**
	 * The function to handle when the button is clicked.
	 */
	onClick: PropTypes.func,

	/**
	 * The children text to display in the button.
	 */
	children: PropTypes.node.isRequired,

};

const defaultProps = {
	color: 'primary'
};

/**
 * Shared component to render a variety of TechChange-style buttons.
 *
 * @param {Object} props The props.
 * @returns {Object} The rendered component.
 */
const TCButton = (props) => {

	const {
		active,
		block,
		className,
		color,
		disabled,
		outline,
		showLoading,
		size,
		onClick,
		children,
	} = props;

	const content =
		showLoading
			? <i className="fas fa-circle-notch fa-spin"></i>
			: children;

	return (
		<Button
			{...props}
			active={active}
			block={block}
			className={className}
			color={color}
			disabled={disabled}
			outline={outline}
			size={size}
			onClick={onClick}>
			{content}
		</Button>
	);

};

TCButton.propTypes = propTypes;
TCButton.defaultProps = defaultProps;

export default TCButton;
